import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../reducers/userInfoReducer';
import { useEffect } from 'react';
import useUserInfo from './useUserInfo';
import useAiAgents from '../components/aiAgentCenter/useAiAgents';
import { useAiAssistant } from '../components/pages/ai-assistant/useAiAssistant';
import { selectCrmOrgHasManagePackage } from '../components/pages/environments/environmentsReducer';
import { useFeatureToggle } from '../feature-flags/useFeatureToggle';
import { useFetchTags } from '../components/documentation/dependencies/annotations/tags/useFetchTags';

/**
 * Add an effect to any call that should be triggered whenever crmOrgId changes
 */

export const useFetchUponCrmOrgChange = () => {
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const isManagePackageInstalled = useSelector(selectCrmOrgHasManagePackage(crmOrgId ?? ''));
  const { supportAgentInAgenticCenter } = useFeatureToggle();
  const { fetchAiAgents } = useAiAgents();
  const { fetchAiAssistentConversations, fetchApps } = useAiAssistant();
  const { getUserPermissions } = useUserInfo();
  const fetchTags = useFetchTags();

  useEffect(() => {
    if (crmOrgId) {
      getUserPermissions(crmOrgId);
    }
  }, [crmOrgId, getUserPermissions]);

  useEffect(() => {
    if (crmOrgId) {
      fetchAiAgents();
    }
  }, [crmOrgId, fetchAiAgents]);

  useEffect(() => {
    // since we load ai agents data on crm org change, we also need toload ai assistant data
    // if manage package is installed and feature flag is enabled
    if (isManagePackageInstalled && supportAgentInAgenticCenter && crmOrgId) {
      fetchApps(crmOrgId);
      fetchAiAssistentConversations(crmOrgId);
    }
  }, [
    crmOrgId,
    fetchAiAssistentConversations,
    fetchApps,
    supportAgentInAgenticCenter,
    isManagePackageInstalled,
  ]);

  useEffect(() => {
    if (crmOrgId) {
      fetchTags();
    }
  }, [crmOrgId, fetchTags]);
};
